export enum SignalValueTrackerStatusTypes {
  RUNNING = 'running',
  COMPLETED = 'completed',
  ERROR = 'error',
}
